import {Circle} from '@chakra-ui/react';
import {resolveStyleConfig, useTheme} from '@chakra-ui/system';
import type {IconDefinition} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {dataAttr} from '@utils';
import {useMemo} from 'react';

import {useStyles} from './context';
import {parts} from './theme/anatomy';
import {itemIconStyles} from './theme/theme';
import type {RadioButtonProps} from '.';

type Props = {
  colorScheme: RadioButtonProps['colorScheme'];
  isHovered: boolean;
  isFocused: boolean;
  isActive: boolean;
  isChecked: boolean;
  icon?: IconDefinition;
  iconProps?: React.ComponentProps<typeof FontAwesomeIcon>;
};
export const RadioButtonIcon = (props: Props) => {
  const {colorScheme, isHovered, isActive, isFocused, isChecked, icon, iconProps} = props;
  const theme = useTheme();
  const {'item-icon': __css} = useStyles();
  // @ts-expect-error: We allow passing here colorScheme as object
  const schemeStyle = useMemo(() => resolveStyleConfig(itemIconStyles)({colorScheme, theme}), [colorScheme, theme]);

  const dataAttrs = {
    'data-hover': dataAttr(isHovered),
    'data-checked': dataAttr(isChecked),
    'data-focus': dataAttr(isFocused),
    'data-active': dataAttr(isActive),
  };

  return (
    <Circle sx={{...__css, ...schemeStyle}} {...parts[`item-container`].attrs} {...dataAttrs}>
      {icon && <FontAwesomeIcon fontSize={`0.75rem`} icon={icon} {...parts[`item-icon`].attrs} {...iconProps} />}
    </Circle>
  );
};
